import React from "react";
import UserGenericSkeleton from "./UserGenericSkeleton";

function UserDetailSkeleton() {
  return (
    <>
      <UserGenericSkeleton />
    </>
  );
}

export default UserDetailSkeleton;
